import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from '@servicios/Seguridad.service';

import {EscalaevaluacionComponent} from './escalaevaluacion/escalaevaluacion.component';
import {CompetenciaComponent} from './competencia/competencia.component';
import {CriterioComponent} from './criterio/criterio.component';

const routes: Routes = [
    {path: '', redirectTo: 'escalaevaluacion', pathMatch: 'full'},
    {path: 'escalaevaluacion', component: EscalaevaluacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'competencia', component: CompetenciaComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'criterio', component: CriterioComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ConfiguracionRoutingModule {}
